var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-text-field", {
    staticClass: "search-field py-0",
    attrs: {
      "prepend-icon": "search",
      "hide-details": "",
      placeholder: _vm.placeholder,
      value: _vm.value,
      "data-testid": "search",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }